import * as Immutable from "immutable";

import { Action } from "./Action";
import { ActionCentre } from "./ActionCentre";
import { Actions, IAction } from "./types";

export class HeaderMenus {
    private actionCentre: ActionCentre;
    private isMenuOpen: boolean;
    private isPhoneOpen: boolean;

    constructor(actionsService: ActionCentre) {
        this.actionCentre = actionsService;
        this.runEventBinding();
    }

    private runEventBinding(): void {
        const body: HTMLElement = document.querySelector("body") as HTMLElement;
        const menuTrigger: HTMLElement = document.querySelector("[data-mobile-menu-trigger]") as HTMLElement;
        const menu: HTMLElement = document.querySelector("[data-mobile-menu]") as HTMLElement;

        const phoneTrigger: HTMLElement = document.querySelector("[data-mobile-phone-trigger]") as HTMLElement;
        const phone: HTMLElement = document.querySelector("[data-mobile-phone]") as HTMLElement;

        const toplevel: NodeListOf<HTMLElement> = document.querySelectorAll(".toplevel") as NodeListOf<HTMLElement>;

        window.addEventListener("touchstart", () => {
            body.classList.add("touchscreen");
        });

        if (menuTrigger) {
            menuTrigger.addEventListener("click", (e) => {
                e.stopPropagation();
                if (this.isMenuOpen) {
                    const action = new Action(Actions.HIDE_OVERLAY, ["showOverlay", false]);
                    this.actionCentre.Do(action);
                    menu.style.display = "none";
                    this.isMenuOpen = false;               
                } else {
                    const action = new Action(Actions.SHOW_OVERLAY, ["showOverlay", true]);
                    this.actionCentre.Do(action);
                    menu.style.display = "block";
                    this.isMenuOpen = true;
                    if (this.isPhoneOpen) {
                        phone.style.display = "none";
                        this.isPhoneOpen = false;
                        phoneTrigger.classList.remove("phone-active");
                        phoneTrigger.innerText = "CALL US";
                    }
                }
            });
        }

        if (phoneTrigger) {
            phoneTrigger.addEventListener("click", (e) => {
                e.stopPropagation();
                if (this.isPhoneOpen) {
                    const action = new Action(Actions.HIDE_OVERLAY, ["showOverlay", false]);
                    this.actionCentre.Do(action);
                    phone.style.display = "none";
                    this.isPhoneOpen = false;
                    phoneTrigger.classList.remove("phone-active");
                    phoneTrigger.innerText = "CALL US";
                } else {
                    const action = new Action(Actions.SHOW_OVERLAY, ["showOverlay", true]);
                    this.actionCentre.Do(action);
                    phone.style.display = "block";
                    this.isPhoneOpen = true;
                    phoneTrigger.classList.add("phone-active");
                    phoneTrigger.innerText = "CLOSE";
                    if (this.isMenuOpen) {
                        menu.style.display = "none";
                        this.isMenuOpen = false;
                    }
                }
            });
        }



        // Tablet first tap = hover.
        if (toplevel) {
            for (let i = 0; i < toplevel.length; i++) {
                toplevel[i].addEventListener("click", (e) => {
                    if (document.querySelector("body").classList.contains("touchscreen") && document.querySelector("body").clientWidth > 1044) {
                        if (!toplevel[i].classList.contains("firstclick")) {
                            // Mark first tap.
                            e.preventDefault();
                            e.stopPropagation();

                            for (let j = 0; j < toplevel.length; j++) {
                                toplevel[j].classList.remove("firstclick");
                            }
                            toplevel[i].classList.add("firstclick");
                        } 
                    }
                });
            }

            // Get rid of first tap marker for tablet.
            body.addEventListener("click", () => {
                for (let i = 0; i < toplevel.length; i++) {
                    toplevel[i].classList.remove("firstclick");
                }
            });
        }

        const overlay: HTMLElement = document.querySelector("[data-overlay]") as HTMLElement;

        if (overlay) {
            overlay.addEventListener("click", (e) => {
                const hideAction = new Action(Actions.HIDE_OVERLAY, ["showOverlay", false]);
                this.actionCentre.Do(hideAction);

                phone.style.display = "none";
                this.isPhoneOpen = false;

                menu.style.display = "none";
                this.isMenuOpen = false;   

                phoneTrigger.classList.remove("phone-active");
                phoneTrigger.innerText = "CALL US";
            });
        }


    }
}



// WEBPACK FOOTER //
// ./src/global/HeaderMenus.ts